// Where the hover position falls in an open entry: per LR tag, the cursor's place on
// its bar or profile and the section (or point pair) under it; the lanes view stretch.
// The glue only moves elements and toggles classes from this.
import {
  axisEndCm,
  buildProfile,
  isProfilePoint,
  profileValueAt,
} from "./positions.mjs";

function stepIndexAt(sections, axis, cm) {
  return sections.findIndex((s, i) => {
    const next = sections.slice(i + 1).find((n) => n.startCm > s.startCm);
    const end = s.endCm ?? (next ? next.startCm : axis);
    return cm >= s.startCm && cm < end;
  });
}

function profileIndicesAt(sections, lengthCm, cm) {
  const at = profileValueAt(buildProfile(sections, lengthCm), cm);
  if (!at) return [-1, -1];
  const pointIndex = (pointCm) =>
    sections.findIndex((s) => isProfilePoint(s) && s.startCm === pointCm);
  if (typeof at.value === "string") {
    const band = sections.findIndex(
      (s) =>
        !isProfilePoint(s) && s.startCm === at.startCm && s.value === at.value,
    );
    return [band, -1];
  }
  if (!at.interpolated) return [pointIndex(at.startCm), -1];
  return [pointIndex(at.startCm), pointIndex(at.endCm)];
}

/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 * @param {{stretches: {startCm: number, endCm: number}[]}|null} laneView
 * @param {number} cm
 * @returns {{tags: {rawKey: string, percent: number, activeIndex: number,
 *   nextIndex: number}[], laneStretch: number}}
 */
export function cursorTargets(model, laneView, cm) {
  const tags = model.groups
    .flatMap((g) => g.tags)
    .filter((t) => t.sections)
    .map((t) => {
      const axis = axisEndCm(model.lengthCm, t.sections);
      const percent = Math.min(Math.max((cm / axis) * 100, 0), 100);
      let indices = [-1, -1];
      if (t.lr === "step") indices = [stepIndexAt(t.sections, axis, cm), -1];
      if (t.lr === "linear")
        indices = profileIndicesAt(t.sections, model.lengthCm, cm);
      return {
        rawKey: t.rawKey,
        percent,
        activeIndex: indices[0],
        nextIndex: indices[1],
      };
    });
  const laneStretch = laneView
    ? laneView.stretches.findIndex((s) => cm >= s.startCm && cm < s.endCm)
    : -1;
  return { tags, laneStretch };
}
